if (!customElements.get('section-showcase')) {
  class SectionShowcase extends HTMLElement {
    constructor() {
      super();

      this.timeline = null;
      this._initialized = false;

      this.deviceToAnimate = this.querySelector('.showcase-device-image');
      this.elementsToAnimate = [
        ...this.querySelectorAll(
          '.showcase-screenshots-image, .showcase-widget'
        )
      ];
    }

    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      gsap.registerPlugin(ScrollTrigger);

      this.initAnimation();
    }

    initAnimation() {
      if (!this.elementsToAnimate.length || !this.deviceToAnimate) return;

      this.timeline = gsap.timeline({
        scrollTrigger: {
          trigger: this,
          start: 'top 70%',
          toggleActions: 'play none none none'
        }
      });

      this.timeline.fromTo(
        this.deviceToAnimate,
        {
          opacity: 0,
          x: 450,
          rotation: 90,
          scale: 0.95
        },
        {
          opacity: 1,
          x: 0,
          rotation: 0,
          scale: 1,
          duration: 0.8,
          ease: 'power3.out'
        }
      );

      this.timeline.fromTo(
        this.elementsToAnimate,
        {
          opacity: 0,
          y: 50,
          scale: 0.95
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.6,
          ease: 'power2.out',
          stagger: 0.35
        },
        '>-0.2'
      );
    }

    disconnectedCallback() {
      this.timeline.kill();
      this.timeline = null;

      ScrollTrigger.getAll().forEach(trigger => {
        if (trigger.trigger === this) {
          trigger.kill();
        }
      });

      this._initialized = false;
    }
  }

  customElements.define('section-showcase', SectionShowcase);
}